<template>
  <v-container fluid >
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Chat Grupal
          </v-card-title>
          <v-card-text class="mensajes-div" style="background-color: #ffffff;">
            <MessageChat v-for="(e, i) in messages" :key="i" :message="e.message" :user="e.user.name" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="input-div">
            <v-text-field
              v-model="message"
              @keyup.enter="sendMessage"
              label="Escribe un mensaje"
              outlined
              dense
              hide-details
              class="input-field"
            ></v-text-field>
            <v-btn icon @click="sendMessage" color="primary">
              <v-icon>mdi-send</v-icon>
            </v-btn>
            <v-btn icon @click="triggerFileInput" color="primary">
              <v-icon>mdi-attachment</v-icon>
            </v-btn>
            <input type="file" @change="handleFileUpload" ref="fileInput" hidden />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MessageChat from './MessageChat.vue';
export default {
  name: 'GrupalChat',
  components: {
    MessageChat
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    }
  },
  data() {
    return {
      message: ''
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file && file.size <= 50000000) { // 50 MB en bytes
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileAsText = e.target.result; // La data del archivo en formato base64
          this.sendMessage(fileAsText, 'file');
        };
        reader.readAsDataURL(file); // Lee el archivo como URL de datos
      } else {
        alert('El archivo es demasiado grande. El tamaño máximo es de 50 MB.');
      }
    },
    sendMessage(content, type = 'text') {
      if (type === 'text') {
        // Para mensajes de texto, usa el campo `message`
        if (this.message.trim() === '') {
          this.$store.commit('setSnackbar', {
            text: 'No puedes enviar mensajes vacíos',
            color: 'error'
          });
          return;
        }
        // console.log('Mensaje a enviar: ', this.message);
        this.$socket.emit('event_message', {
          room: this.$route.params.projectId,
          message: this.message,
          user: { name: `${localStorage.getItem("email")}` },
          type: 'text'
        });
        this.message = ''; // Limpiar el input de texto
      } else if (type === 'file') {
        // Para archivos (content contiene el archivo en base64)
        // console.log('Archivo a enviar: ', content);
        this.$socket.emit('event_message', {
          room: this.$route.params.projectId,
          message: content, // El archivo en base64
          user: { name: `${localStorage.getItem("email")}` },
          type: 'file'
        });
      }
    }
  },
}
</script>

<style scoped>
.mensajes-div {
  height: 60vh;
  padding: 10px;
  overflow-y: scroll;
}

.input-div {
  display: flex;
  align-items: center;
}

.input-field {
  flex: 1;
}
</style>